import { render, staticRenderFns } from "./UserNav.vue?vue&type=template&id=ef51e420&scoped=true&"
import script from "./UserNav.vue?vue&type=script&lang=js&"
export * from "./UserNav.vue?vue&type=script&lang=js&"
import style0 from "./UserNav.vue?vue&type=style&index=0&id=ef51e420&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef51e420",
  null
  
)

export default component.exports